module.exports = __webpack_public_path__ + "static/media/3.74bcee51.jpg";